import { render, staticRenderFns } from "./TableHistoricRegistresLift.vue?vue&type=template&id=e3dc4d24"
import script from "./TableHistoricRegistresLift.vue?vue&type=script&lang=js"
export * from "./TableHistoricRegistresLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports